define('lib/audio/check-error',[],function () {
    var isRestrictedRegex = function (text) {
        var tagRegex = '.*[<>].*';
        var unicodeRegex = '.*\\\\\\d+.*';
        var decimalRegex = '.*&#x?\\d*?;.*';
        var privateRegex = new RegExp(tagRegex + '|' + unicodeRegex + '|' + decimalRegex);

        return privateRegex.test(text);
    };

    return function (audio) {
        return {
            isBuiltInError: !audio.isPrivate && !audio.isVoip && !audio.isToll && !audio.isTollFree && !audio.isDialOut,

            privateRestrictedRegex: audio.isPrivate && isRestrictedRegex(audio.privateMessage),

            isPrivateError: audio.isPrivate && (!audio.privateMessage)
        };
    };
});

